export default __webpack_public_path__ + "static/media/hospital_logo.d04c7145.svg";